import styles from './form-sucess.module.scss';
import Image from 'next/image';

type FormSuccessProps =  {
  title: string;
  text: string;
  className?: string;
}

export const FormSuccess = ({title, text, className}: FormSuccessProps) => {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <div className={styles.icon}>
        {/* todo: replace with ReactSVG */}
        <Image
          src={"/shared/checkmark.svg"}
          alt={"Checkmark"}
          width={40}
          height={34}
          layout={"fixed"}
          objectFit={"contain"}
        />
      </div>
      <h4 className={styles.title}>{title}</h4>
      <span className={styles.text}>{text}</span>
    </div>
  );
}
